<template>
  <v-app>
    <Toolbar :current="current" />
    <v-content>
      <router-view @hbhead="hbhead"></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Toolbar from "@/components/Toolbar.vue";

export default {
  name: "App",

  components: {
    Footer,
    Toolbar,
  },
  data() {
    return {
      current: 0,
    };
  },
  methods: {
    hbhead(num) {
      this.current = num;
    },
  },
};
</script>
